import styled from "styled-components";

import { deviceQueries } from "../../common.styled";

export const ContactSection = styled.section`
    text-align: center;

    .pretitle {
        counter-increment: title 4;
        font-family: var(--font-mono);
        color: var(--green);
        font-size: var(--fz-md);
        margin: 0.5rem auto 1.25rem;
        display: block;
    }

    h2 {
        font-size: clamp(40px, 5vw, 60px);
        margin-bottom: 1.25rem;
    }

    p {
        max-width: 40rem;
        margin: auto;
        margin-bottom: 3rem;
    }

    #contactform {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        opacity: 1;

        .input__container {
            flex: 0 0 100%;

            input,
            textarea {
                width: 100%;
                padding: 1rem 1.25rem;
                font-size: var(--fz-md);
                font-family: var(--font-mono);
                background-color: var(--light-navy);
                border-width: 0;
                border-radius: var(--border-radius);
                color: var(--light-slate);
                transition-duration: .5s;

                &:focus,
                &:focus-visible {
                    outline: 1px solid var(--green);
                }

                &::placeholder {
                    color: var(--light-slate);
                    opacity: .6;
                }

                &[type=submit] {
                    margin-top: 1rem;
                    color: var(--green);
                    background-color: transparent;
                    border: 1px solid var(--green);
                    border-radius: var(--border-radius);
                    padding: 1.25rem 1.75rem;
                    font-size: var(--fz-sm);
                    font-family: var(--font-mono);
                    line-height: 1;
                    text-decoration: none;
                    cursor: pointer;
                    transition: var(--transition);
                    display: inline-block;
                    width: unset;

                    &:hover {
                        background-color: var(--green-tint);
                    }
                }
            }

            textarea {
                resize: none;
            }
        }

        #form__submit {
            position: relative;

            .formnotice {
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                border-radius: .25rem;
                color: white;
                padding: 1rem;
                opacity: 1;
                pointer-event: initial;
                transition-duration: .8s;
                display: block;
                z-index: 5;

                &.success {
                    background: #28a745;
                }
                &.error {
                    background: #dc3545;
                }

                &.hide {
                    transform: translateX(-50%) translateY(50px);
                    opacity: 0;
                    pointer-event: none;
                    z-index: -1;
                }
            }
        }
    }

    &.reduced {
        #contactform {
            input, textarea {
                opacity: .3
            }   
        }
    }

    &.success {
    }

    @media ${deviceQueries.laptop} {
        form {
            .input__container {
                &.half {
                    flex: 0 0 calc(50% - .5rem);
                }
            }
        }
    }
`;
